// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1-i8D","fullScreen":"style_fullScreen__20g5L","hidden":"style_hidden__wasaA"};